import { render } from "./AntiSocial.vue?vue&type=template&id=32f330ff"
import script from "./AntiSocial.vue?vue&type=script&lang=js"
export * from "./AntiSocial.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__